export default {
    bookings: [],
    activeBooking: {
        startDate: new Date().toISOString().substr(0, 10),
        startTime: '08:30',
        total: 0.00,
        discountValue: null
    },
    manageBookingDialog: false,
    deleteBookingDialog: false
}
